/* eslint-disable */

import { stickyHeader } from "./sticky-header.js";
import { checkTouchDevice } from "./check-touch-device.js";
import { navigation } from "./navigation.js";

// Call the function
stickyHeader();
checkTouchDevice();
navigation();
